import { FC, ReactNode, useMemo } from 'react'
import styles from 'components/features/future/FutureInputDecoration/FutureInputLayout.styl'
import { FutureInputDecorationLabel } from 'components/features/future/FutureInputDecoration/FutureInputDecorationLabel'
import { InputStateTheme } from 'components/atoms/inputs/InputStateTheme/InputStateTheme'
import { useInputTheme } from 'components/features/theme/useInputTheme'
import cn from 'classnames'

type FutureInputLayoutProps = {
  label?: ReactNode
  note?: ReactNode
  error?: ReactNode
  units?: ReactNode
  className?: string
}
export const FutureInputLayout: FC<FutureInputLayoutProps> = (props) => {
  const { children, label, note, error, units, className } = props

  const { inputDisabled } = useInputTheme()

  const noteChild = useMemo(() => {
    if (!note) {
      return null
    }

    return (
      <div className={ styles.note }>
        { note }
      </div>
    )
  }, [note])

  const errorChild = useMemo(() => {
    if (!error) {
      return null
    }

    return (
      <div className={ styles.error }>
        { error }
      </div>
    )
  }, [error])

  const unitsChild = useMemo(() => {
    if (!units) {
      return null
    }
    return (
      <div className={ styles.units }>
        { units }
      </div>
    )
  }, [units])

  const labelChild = useMemo(() => {
    if (!label) {
      return null
    }

    return (
      <div className={ styles.label }>
        <FutureInputDecorationLabel>
          { label }
        </FutureInputDecorationLabel>
      </div>
    )
  }, [label])

  return (
    <InputStateTheme hasError={ !!error }>
      <div className={ cn(styles.futureInputLayout, inputDisabled && styles.disabled, className) }>
        { labelChild }
        { noteChild }
        <div className={ cn(styles.content) } >
          { children }
          { unitsChild }
        </div>
        { errorChild }
      </div>
    </InputStateTheme>
  )
}
